<template>
  <div class="layout">
    <!-- 顶部导航 -->
    <SiteHeader  :is_login_page="false"/>

    <!-- 搜索栏 -->
    <div class="content">
      <div class="search-bar">
        <div class="search-input-container">
          <!-- 关键词标签 -->
          <div v-for="(keyword, index) in keywords" :key="index" class="keyword">
            {{ keyword }}
            <span class="remove-keyword" @click="removeKeyword(index)">×</span>
          </div>
          <!-- 输入框 -->
          <input
            type="text"
            v-model="searchQuery"
            @input="handleInput"
            @keydown.enter="addKeyword"
            @focus="showSuggestions = true"
            @blur="hideSuggestions"
            :placeholder="placeholdertext"
            class="search-input"
          />
          <!-- 联想框 -->
          <div v-if="showSuggestions && suggestions.length > 0" class="suggestions">
            <div
              v-for="(suggestion, index) in suggestions"
              :key="index"
              class="suggestion-item"
              @mousedown="selectSuggestion(suggestion)"
            >
              {{ suggestion }}
            </div>
          </div>
        </div>
        <button class="search-button" @click="handleSearch">搜索</button>
      </div>

      <!-- 卡片列表 -->
      <div class="card-list">
        <div
          v-for="(card, index) in filteredCards"
          :key="index"
          class="card"
          @click="goToCardDetail(card.t_id)"
        >
          <div class="avatar_container">
            <img :src="card.avatar" alt="头像" class="avatar">
          </div>
          <div class="first_section">
            <div class="name">{{ card.name }}</div>
            <div class="features item_layout">
              <div class="item_title">头衔/职务：</div>
              <div class="item_content">{{ getTrunc(card.title,10) }}</div>
              
            </div>
            <div class="course_domain item_layout">
              <div class="item_title">授课领域：</div>
              <div class="item_content">{{ getTrunc(card.teach_domain,10) }}</div>
            </div>
            <div class="course">
              <div class="item_content"><span class="item_title">教授课程：</span>{{ getTrunc(card.courses,27) }}</div>
            </div>
          </div>
          <div class="second_section">
            <div class="item_title">师资亮点：</div>
            <div class="item_content">{{ getTrunc(card.features,57) }}</div>
          </div>
          <div class="last_section">
            <div class="item_title">简介：</div>
            <div class="item_content desc_content"> {{ card.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import SiteFooter from '@/components/SiteFooter.vue';
import SiteHeader from '@/components/SiteHeader.vue';
import axios from 'axios';
export default {
  name: 'LayoutComponent',
  components: {
    SiteFooter,
    SiteHeader
  },
  data() {
    return {
      searchQuery: '',
      showSuggestions: false,
      suggestions: [], // 联想词列表
      keywords: [], // 已输入的关键词
      alltag:[],
      cards: []
    };
  },
  computed: {
    filteredCards() {
      return this.cards;
    },
    placeholdertext(){
      return this.keywords.length > 0 ? '':'请输入关键词，按回车确认';
    }
  },
  created(){
    this.verifyToken();
    this.getAllTags();
    this.getTeachers();
  },
  methods: {
    getTrunc(content, length) {
      // 截取指定长度的字符串，例如前5个字符
      return content.length > length ? content.slice(0, length) + "...":content.slice(0, length);
    },
    async getTeachers(){
      try {
            let token = localStorage.getItem('token'); // 存储 token
            let keywords = this.keywords;
            if( keywords.length <= 0 )
            {
               keywords = JSON.parse(localStorage.getItem('keywords')); // 存储 keywords
               if(keywords)
               {
                this.keywords = keywords
               }
              //  this.keywords = keywords;
            }
            const response = await axios.get('https://pay.4reasons.cn/teacher-user/search-teacher', {
              headers: {
                  'Authorization': 'Bearer '+token, 
                },
                params: {
                  tags: this.keywords
                }
            });

            let code = response.data.code;
            console.log(response.data)
            if( code == '1000' )
            {
              this.cards = response.data.data
            }
        } catch (error) {
            console.error(error);
        }
    },
    async verifyToken(){
      try {
            let token = localStorage.getItem('token'); // 存储 token
            const response = await axios.get('https://pay.4reasons.cn/teacher-user/verify-token', {
              headers: {
                  'Authorization': 'Bearer '+token, 
              }
            });

            let code = response.data.code;
            console.log(response.data)
            if( code != '1000' )
            {
              this.$router.push(`/login`);
            }
        } catch (error) {
            console.error(error);
        }
    },
    async getAllTags(){
      try {
            let token = localStorage.getItem('token'); // 存储 token
            const response = await axios.get('https://pay.4reasons.cn/teacher-user/keywords', {
              headers: {
                  'Authorization': 'Bearer '+token, 
                }
            });

            this.alltag = response.data.data;
            
        } catch (error) {
            console.error(error);
        }
    },
    async getTeacher(){
      try {
            let token = localStorage.getItem('token'); // 存储 token
            const response = await axios.get('https://pay.4reasons.cn/teacher-user/keywords', {
              headers: {
                  'Authorization': 'Bearer '+token, 
                }
            });

            this.alltag = response.data.data;
            
        } catch (error) {
            console.error(error);
        }
    },
    handleInput() {
      // 模拟联想词数据`
      if (this.searchQuery) {
        this.suggestions = this.alltag.filter((item) =>
          item.toLowerCase().includes(this.searchQuery.toLowerCase())
        );
      } else {
        this.suggestions = [];
      }
    },
    hideSuggestions() {
      // 延迟隐藏联想框，避免点击联想词时无法触发
      setTimeout(() => {
        this.showSuggestions = false;
      }, 200);
      this.addKeyword();
    },
    selectSuggestion(suggestion) {
      if (this.searchQuery && !this.keywords.includes(suggestion)) {
        this.keywords.push(suggestion); // 添加关键词
        this.searchQuery = ''; // 清空输入框
      }
      this.showSuggestions = false; // 隐藏联想框
      this.suggestions = [];
      this.getTeachers();
    },
    addKeyword() {
      if (this.searchQuery && !this.keywords.includes(this.searchQuery)) {
        this.keywords.push(this.searchQuery); // 添加关键词
        this.searchQuery = ''; // 清空输入框
      }
      this.showSuggestions = false; // 隐藏联想框
      this.suggestions = [];
      this.getTeachers();
    },
    removeKeyword(index) {
      this.keywords.splice(index, 1); // 移除关键词
      console.log(this.keywords)
      this.suggestions = [];
      localStorage.setItem('keywords',JSON.stringify(this.keywords));
      this.getTeachers();      
    },
    handleSearch() {
      console.log('当前关键词:', this.keywords);
      // 这里可以添加搜索逻辑
      this.getTeachers();
    },
    handleLogout() {
      alert('退出登录');
    },
    goToCardDetail(t_id) {
      this.$router.push(`/card/${t_id}`);
      localStorage.setItem('keywords',JSON.stringify(this.keywords)); // 存储 keywords
    },
  },
};
</script>

<style scoped>
  * { 
    margin: 0; 
    padding: 0; 
    box-sizing: border-box; 
  }
  body{
    margin:0; 
    padding:0; 
    box-sizing: border-box; 
    background-color: #F5F5F5;
  }
  .layout {
    width: 100%;
    display: flex;
    flex-direction: column;
    font-family: Arial, sans-serif;
  }
  .content{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #F5F5F5;
    padding-bottom: 92px;
  }
  /* 搜索栏 */
  .search-bar {
    display: flex;
    justify-content: center;
    padding: 16px;
    position: relative;
    margin-top:96px;
  }

  .search-input-container {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 600px;
    padding-left:20px;
    padding-right:40px;
    /* border: 1px solid #ddd; */
    border-radius:30px;
    background-color: #FFFFFF;
  }

  .keyword {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    background-color: #555;
    color: white;
    border-radius: 4px;
    font-size: 0.875rem;
    
  }

  .remove-keyword {
    margin-left: 4px;
    cursor: pointer;
    font-size: 0.75rem;
  }

  .remove-keyword:hover {
    color: #ff4d4d;
  }

  .search-input {
    flex: 1;
    min-width: 100px;
    padding-left: 20px;
    border: none;
    outline: none;
    font-size: 1rem;
    border-radius:30px;
    background-color: #FFFFFF;
    padding-right:40px;
  }

  .suggestions {
      position: absolute;
      top: 100%;
      left: 0;
      width: 100%; /* Set suggestions box width to 100% */
      max-width: 600px; /* Limit the max-width to match the search input container */
      background-color: white;
      border: 1px solid #ddd;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      z-index: 10;
  }

  .suggestion-item {
    padding: 8px;
    cursor: pointer;
  }

  .suggestion-item:hover {
    background-color: #f0f0f0;
  }

  .search-button {
    margin-left:-30px;
    width: 102px;
    height: 81px;
    background-color: #FF6864;
    border: none;
    padding-top: 20px;
    padding-bottom: 20px;
    border-radius: 0 30px 30px 0;
    cursor: pointer;
    background-image: url('../assets/search_icon.png');
    background-size: 41px 41px; 
    background-repeat: no-repeat;
    background-position: center;
    border: none; 
    text-indent: -9999px; 
    z-index: 10;
  }

  .search-button:hover {
    background-color: #ef0d0d;
  }

  /* 卡片列表 */
  .card-list {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    flex-wrap: wrap;
    gap: 26px;
    /* padding: 16px; */
    margin-top:92px;
    min-height: calc(100vh - 269px -87px -76px);
    /* border: 1px solid #ef0d0d; */
    background-color: #F5F5F5;
  }
  .card {
    width: 1512px;
    height: 231px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    display:flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #FFFFFF;
  }
  .avatar_container{
    padding-left: 29px;
    padding-top:25px;
    padding-bottom:25px;
  }
  .avatar {
    width: 184px;
    height: 184px;
    /* border-radius: 50%; */
    object-fit: cover;
  }
  .item_title{
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    font-size: 20px;
    /* color: #454545; */
    color: #191919;
    line-height: 30px;
  }
  .item_content{
    font-family: AlibabaPuHuiTi-Regular;
    font-weight: 500;
    font-size: 20px;
    color: #454545;
    line-height: 30px;
  }
  .desc_content{
    line-height: 33px;
  }
  .item_layout{
    display:flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  .first_section{
    width: 352px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: left;
    margin-left:30px;
    margin-top:25px;
    /* border: 1px solid #ef0d0d; */
    max-height: 184px;
    gap:12px;
  }

  .name{
    font-family: AlibabaPuHuiTi-Medium;
    font-weight: 500;
    font-size: 24px;
    color: #191919;
    line-height: 41px;
    /* border: 1px solid blue; */
  }
  .second_section{
    width: 255px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: left;
    margin-top:25px;
    margin-left:58px;
    max-height: 184px;
    /* border: 1px solid blue; */
  }
  .last_section{
    width: 468px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: left;
    margin-top:25px;
    margin-left:70px;
    max-height: 184px;
  }
</style>